import memoize from 'memoize-one';

const columns = memoize(() => [
  {
    name: 'FECHA',
    selector: 'real_marking_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'HORA',
    selector: 'parsed_time',
    sortable: true,
    center: true,
    grow: '1'
  },
  {
    name: 'TIPO',
    selector: 'time_type',
    cell: item => item.translated_time_type,
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'MODALIDAD',
    selector: 'translated_device_type',
    cell: item => (item.translated_device_type ? item.translated_device_type : item.translated_marking_type),
    sortable: false,
    grow: '2',
    center: true
  }
]);

export default columns;
